export { default as TickIcon } from './tick-icon';
export { default as ChangePasswordIcon } from './change-password-icon';
export { default as ConsolidationIcon } from './consolidation-icon';
export { default as CurrencyIcon } from './currency-icon';
export { default as LogoutIcon } from './logout-icon';
export { default as TouchIdIcon } from './touchId-icon';
export { default as StatementIcons } from './statement-icons';
export { default as TransactionIcon } from './transaction-icon';
export { default as PDFicons } from './pdf-icon';
export { default as DownloadIcon } from './download-icon';
export { default as CreditviewIcon } from './creditview-icon';
export { default as ExcelIcon } from './excel-icon';
export { default as PositionsIcon } from './positions-icon';
export { default as TransactionsIcon } from './transactions-icon';
export { default as NotificationIcon } from './notification-icon';
export { default as UpArrowIcon } from './up-arrow-icon';
export { default as RMCallBackIcon } from './rmcallback-icon';
export { default as AlertManegement } from './alert-message-management-icon';
export { default as AccountManegement } from './account-management-icon';
export { default as AppAnalytics } from './app-analytics-icon';
export { default as QuestionMark } from './question-mark';
export { default as FeedbackIcon } from './feedback-icon';
export { default as TermsCondition } from './terms-condition-icon';
export { default as VascoFailIcon } from './vasco-fail-icon';
export { default as AccountLanguage } from './account-language-icon';
export { default as GenerateOTPIcon } from './generate-otp-icon';
export { default as InternalTransferIcon } from './internal-transfer-icon';
export { default as PaperlessEnrollmentIcon } from './paperless-enrollment-icon';
export { default as AccordionPlusIcon } from './accordion-plus-icon';
export { default as AccordionMinusIcon } from './accordion-minus-icon';

// service icon
export { default as PaymentIcon } from './payment-icon';export { default as PortfolioIcon } from './portfolio-icon';
export { default as MaturitiesIcon } from './maturities-icon';
export { default as InsightsIcon } from './insights-icon';
export { default as ReportsIcon } from './reports-icon';
export { default as ProfileIcon } from './profile-icon';
export { default as CallDeskPhoneIcon } from './call-desk-phone-icon';
export { default as EmailIcon } from './email-icon';

// interaction icon
export { default as EditIcon } from './edit-icon';
export { default as CrossIcon } from './cross-icon';
export { default as SearchIcon } from './search-icon';

// status icon
export { default as ErrorIcon } from './error-icon';
export { default as SuccessIcon } from './success-icon';
export { default as WarningIcon } from './warning-icon';

// service-special assets
export { default as PaymentMobileConfirmStep1 } from './payment-mobile-confirm-step1'
export { default as PaymentMobileConfirmStep2 } from './payment-mobile-confirm-step2'
export { default as PaymentMobileConfirmStep3 } from './payment-mobile-confirm-step3'
export { default as LoginCircle } from './login-circle';

//filter-icon
export { default as FilterIcon } from './filter-icon';
export {default as DbLogoText } from './db-logo-text';
export { default as Gear } from './gear';
export {default as Calendar} from './calendar';
export { default as DocCenter } from './doc-center';
export { default as DbLogo } from './db-logo';
export { default as DbText } from './db-text';

export {default as DotIcon} from './dot-icon' 
